import { setSettingsCookie } from '@js/globalFunctions/cookieHandling'

export function updateSelectedAreas( selectedAreaHolder, forceDisplay )
{
	resetSelectedAreas( selectedAreaHolder.length );
	var inputLength 		= $('.areaDotSelect').length;
	var selectedLength 		= selectedAreaHolder.length;
	var forceDisplay 		= (typeof forceDisplay === 'undefined' || ( selectedLength !== 0 && selectedLength !== inputLength ) ) ? false : forceDisplay ;
	var selectedString 		= '';

	for(var i = 0; i < selectedLength; i++ )
	{
		const visibleSlug = typeof window.dataholder.areaConvertions[selectedAreaHolder[i]] !== 'undefined' ? window.dataholder.areaConvertions[selectedAreaHolder[i]] : selectedAreaHolder[i];
		if( selectedAreaHolder[i].length > 0 )
		{
			$('.areaDotSelect[data-slug='+visibleSlug+']').removeClass('notSelected');
			$('.areaDotSelect[data-slug='+visibleSlug+']').addClass('selected');
			$('.areaDotSelect[data-slug='+visibleSlug+'] input').prop('checked',true);
			selectedString += selectedAreaHolder[i]+',';
		}
	}

	if( (selectedLength) === inputLength || forceDisplay )
	{
		$('.selectAllAreaInputs').prop('checked', true);
	}


	var noneSelected = false;
	if( typeof dataholder.mtm_settings.noAreaSelected !== 'undefined' && dataholder.mtm_settings.noAreaSelected === true )
	{
		noneSelected = true;
	}

	if( !$('select[name=omraader]').hasClass('highlight') )
	{
		$('select[name=omraader]').addClass('highlight');
	}

	if( selectedLength === 0 || forceDisplay ){

		updateAreaSelectText( selectedAreaHolder );
		if( dataholder.prevAreaHolder === false && noneSelected !== true || forceDisplay )
		{
			var els = $('.areaDotSelect');
			for( var i = 0; i < inputLength; i++ )
			{
				$(els[i]).prop('checked', true);
				$(els[i]).addClass('selected');
				$(els[i]).find('input').prop('checked', true);
				var slug = $(els[i]).attr('data-slug');
				if( typeof slug !== 'undefined' )
				{
					selectedAreaHolder.push($(els[i]).attr('data-slug'));
				}
			}
		}
		else
		{
			searchParameters.removeParameter('omraader')
			setSettingsCookie('noAreaSelected', true);
		}

	}
	else
	{
		setSettingsCookie('noAreaSelected', false);
		if( !$('select[name=omraader]').hasClass('highlight') )
		{
			$('select[name=omraader]').addClass('highlight');
		}
		updateAreaSelectText( selectedAreaHolder );
		if( selectedLength === inputLength )
		{
			searchParameters.removeParameter('omraader')
			$('.selectAllAreaInputs').prop('checked', true);
			if( !$('.areasNorth').hasClass('selected') )
			{
				$('.areasNorth').addClass('selected');
			}
			if( !$('.areasSouth').hasClass('selected') )
			{
				$('.areasSouth').addClass('selected');
			}
		}
		else
		{
			selectedString = selectedString.slice(0, -1);
			searchParameters.setParameter('omraader', selectedString)
		}
	}
	dataholder.prevAreaHolder = selectedAreaHolder;
}

function resetSelectedAreas( length )
{
	var dots = $('.areaDotSelect');
	var checkBoxes = $('.areaSelectInput');

	for(var i = 0; i < dots.length; i++){
		$(dots[i]).removeClass('selected');
		$(dots[i]).removeClass('notSelected');
		$(dots[i]).find('input').prop('checked',false);
		if( length !== 0 )
		{
			$(dots[i]).addClass('notSelected');
		}
	}
	for(var i = 0; i < checkBoxes.length; i++){
		$(checkBoxes[i]).prop('checked',false);
	}

}

function updateAreaSelectText( selectedAreaHolder )
{
	var inputLength 		= $('.areaSelectInput').length;
	var selectedLength 		= selectedAreaHolder.length;

	if( selectedLength === 0 ){
		$('#areaSelector option[value=none]').text(wpTranslatedStrings.searchFilterNames.omraader);
	}
	else if(selectedLength === 1 )
	{
		if( selectedAreaHolder[0] !== '' )
		{
			const visibleSlug = typeof window.dataholder.areaConvertions[selectedAreaHolder[0]] !== 'undefined' ? window.dataholder.areaConvertions[selectedAreaHolder[0]] : selectedAreaHolder[0];
			var text = $('.areaDotSelect[data-slug='+visibleSlug+']').find('a').text();
			$('#areaSelector option[value=none]').text(text);
		}
	}
	else
	{
		if( (selectedLength+1) === inputLength )
		{
			$('#areaSelector option[value=none]').text(wpTranslatedStrings.searchFilterNames.omraader);
		}
		else
		{
			var modString = wpTranslatedStrings.searchFilterNames.omraaderFlere.replace('%i', selectedLength);
			$('#areaSelector option[value=none]').text(modString);
		}
	}
}
